module.exports = __webpack_public_path__ + "static/inhaltsverzeichnis_hb8-2371a46443d3516cbd4a607d49457462.pdf";